<template>
  <div class="content ht-100v pd-0">
    <main-header txt="Зөрчил" />
    <div class="content-body">
      <div class="container pd-0-f">
        <div class="row row-xs">
          <div class="col-md-6 col-xl-4 order-md-1 order-xl-0 pd-t-0-f">
            <div class="card">
              <div class="card-header d-flex align-items-center justify-content-between">
                <h6 class="mg-b-0">Ослын тоо</h6>
                <div class="tx-13 d-flex align-items-center">
                  Дүүргээр
                </div>
              </div><!-- card-header -->
              <div class="card-body pd-0">
                <div class="pd-y-25 pd-x-20">
                  <apexchart :key="chartKey" :options="chartOptions" :series="series"></apexchart>
                </div>
                <div class="table-responsive">
                  <table class="table table-borderless table-dashboard table-dashboard-one">
                    <thead class="bd-b">
                      <tr>
                        <th class="wd-40">Дүүрэг</th>
                        <th class="wd-35 text-right">Зөрчил</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(t, i) in list1" :key="i">
                        <td class="tx-medium">{{ t.districtName }}</td>
                        <td class="text-right">{{ t.count }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div><!-- table-responsive -->
              </div><!-- card-body -->
            </div>

            <div class="card mg-t-20">
              <div class="card-header d-flex align-items-center justify-content-between">
                <h6 class="mg-b-0">Саадын тоо</h6>
                <div class="tx-13 d-flex align-items-center">
                  Дүүргээр
                </div>
              </div><!-- card-header -->
              <div class="card-body pd-0">
                <div class="pd-y-25 pd-x-20">
                  <apexchart :key="chartKey1" :options="chartOptions1" :series="series1"></apexchart>
                </div>
                <div class="table-responsive">
                  <table class="table table-borderless table-dashboard table-dashboard-one">
                    <thead class="bd-b">
                      <tr>
                        <th class="wd-40">Дүүрэг</th>
                        <th class="wd-35 text-right">Зөрчил</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(t, i) in list2" :key="i">
                        <td class="tx-medium">{{ t.districtName }}</td>
                        <td class="text-right">{{ t.count }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div><!-- table-responsive -->
              </div><!-- card-body -->
            </div>

          </div>
          <div class="col-lg-12 col-xl-8 pd-t-0-f">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import VueApexCharts from "vue-apexcharts";

import { request } from "@/api/all";



export default {
  components: {
    apexchart: VueApexCharts,
    mainHeader: () => ({
      component: import("@/views/apps/penalty/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      list: [],
      list1: [],
      list2: [],
      chartKey: 0,
      chartKey1: 0,
      series: [],
      series1: [],
      chartOptions: {
        legend: {
          show: false,
        },
        chart: {
          type: 'pie',
        },
        labels: [],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
      chartOptions1: {
        legend: {
          show: false,
        },
        chart: {
          type: 'pie',
        },
        labels: [],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
    }
  },
  mounted() {
    this.loadDta();
    this.loadDtaSaad();
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    loadDta() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TrafficData/hzbhAccidentCountByDistrict" },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.list1 = res.data.list1;
          //this.list= res.data.list;
          //console.log(res,' res');
          this.series = res.data.list1.map(x => x.count);
          //console.log('res.data.list1.map(x => x.count)', res.data.list1.map(x => x.count), res.data.list1.map(x => x.districtName));
          this.chartOptions.labels = res.data.list1.map(x => x.districtName);
          this.chartKey++;
        }
      });
    },
    loadDtaSaad() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TrafficData/hzbhSaadCountByDistrict" },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.list2 = res.data.list1;
          this.series1 = res.data.list1.map(x => x.count);
          this.chartOptions1.labels = res.data.list1.map(x => x.districtName);
          this.chartKey1++;
        }
      });
    },
  }
}
</script>

<style>
</style>